import tileRowSize from './tileRowSize.js';
import planTabTileRowSize from './planTabTileRowSize.js';

const calculateTileRowSize = activeStatus => {
  const width = document.documentElement.clientWidth;
  return activeStatus == 'plan'
    ? planTabTileRowSize(width)
    : tileRowSize(width);
};

export default calculateTileRowSize;
